import { cx } from '@/cva.config';

interface TechChipsProps {
  className?: string;
  max?: number;
  tech: string[];
}

export const TechChips = ({ tech, max = 4, className }: TechChipsProps) => (
  <div className={cx('flex flex-wrap items-center gap-1', className)}>
    {tech.slice(0, max).map((tag) => (
      <span
        className="rounded-sm bg-border/50 px-1.5 py-px font-mono text-2xs lg:text-xs text-foreground-muted"
        key={tag}
      >
        {tag}
      </span>
    ))}
    {tech.length > max && (
      <span className="font-mono text-2xs lg:text-xs text-subtle">
        +{tech.length - max}
      </span>
    )}
  </div>
);
